export const AUTHORIZATION_KEY = "web2chat_token";

export const DEFAULT_FORM_VALIDATION_MESSAGES = {
  email: "Enter a valid email",
  required: "${label} is required!",
};
